import { Link } from 'gatsby'
import { useLocation } from '@reach/router'
import { makeEventTrack, sendEvent } from 'src/utils/restructure/analytics'

import LogOut from './LogOut'

const loggedLinks = [
  {
    text: 'Minha conta',
    url: '/account/',
    areaLabel: 'Ir para minha conta',
    testId: 'my-account-link',
  },
  {
    text: 'Meus pedidos',
    url: '/account/orders',
    areaLabel: 'Ir para meus pedidos',
    testId: 'my-orders-link',
  },
  {
    text: 'Trocas e devoluções',
    url: '/account/exchanges',
    areaLabel: 'Ir para trocas e devoluções',
    testId: 'my-exchanges-link',
  },
  {
    text: 'Clube Decathlon',
    url: '/clube',
    areaLabel: 'Ir para clube decathlon',
    testId: 'clube-link',
  },
]

const LoggedInContent = () => {
  const location = useLocation()

  function handleClick(e: React.MouseEvent<HTMLElement>) {
    const event = makeEventTrack({
      eventAction: e.currentTarget.innerText,
      eventPage: location.pathname === '/' ? 'home' : location.pathname,
    })

    sendEvent(event)
  }

  return (
    <div>
      <ul className="flex flex-col gap-3">
        {loggedLinks.map((links) => {
          return (
            <li
              className="text-sm font-normal font-inter hover:font-semibold"
              key={links.url}
              data-testid={`login-dropdown-${links.text
                .toLowerCase()
                .replace(/\s/g, '-')}-link`}
            >
              <Link
                aria-label={links.areaLabel}
                data-testid={links.testId}
                to={links.url}
                onClick={(e) => handleClick(e)}
              >
                {links.text}
              </Link>
            </li>
          )
        })}
      </ul>
      <div className="block w-full h-px bg-neutral04 my-3" />

      <LogOut className="text-sm" />
    </div>
  )
}

export default LoggedInContent
